import { render, staticRenderFns } from "./DatasetSources.vue?vue&type=template&id=b3685400&scoped=true&"
import script from "./DatasetSources.vue?vue&type=script&lang=js&"
export * from "./DatasetSources.vue?vue&type=script&lang=js&"
import style0 from "./DatasetSources.vue?vue&type=style&index=0&id=b3685400&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3685400",
  null
  
)

export default component.exports